import React from "react";
import { Navigate, useParams } from "react-router-dom";

const getAllClassesTarget = (value: string) => {
  const slug = value.toLowerCase();

  if (slug.includes("class-7")) return "/all-classes?class=class-7";
  if (slug.includes("class-8")) return "/all-classes?class=class-8";
  if (slug.includes("class-9")) return "/all-classes?class=class-9";
  if (slug.includes("class-10")) return "/all-classes?class=class-10";
  if (slug.includes("class-11")) return "/all-classes?class=class-11";
  if (slug.includes("class-12")) return "/all-classes?class=class-12";

  if (slug.includes("neet")) return "/all-classes?class=class-11&subject=Biology";
  if (slug.includes("jee")) return "/all-classes?class=class-11&subject=Maths";

  return "/all-classes";
};

const CourseRedirect: React.FC = () => {
  const params = useParams();
  const joinedSlug = Object.values(params).filter(Boolean).join("-");
  const target = getAllClassesTarget(joinedSlug || "all-classes");

  return <Navigate to={target} replace />;
};

export default CourseRedirect;
